import React from 'react'
import { Typography, Box } from '@mui/material'
import StudentNotes from '../components/StudentNotes'
import { SectionHeader, PageContainer } from '../components/ui/StyledComponents'
import { useParams } from 'react-router-dom'

const StudentNotesPage = () => {
  const { studentId } = useParams()

  return (
    <PageContainer>
      <Box sx={{ my: { xs: 2, sm: 3, md: 4 } }}>
        <SectionHeader 
          variant="h2" 
          component="h1"
          sx={{ 
            fontSize: { xs: '1.5rem', sm: '2rem', md: '2.125rem' },
            mb: { xs: 1.5, sm: 2 },
          }}
        >
          Student Notes
        </SectionHeader>
        {studentId ? (
          <Typography 
            variant="subtitle1" 
            component="h2" 
            gutterBottom 
            color="text.secondary"
            sx={{ 
              fontSize: { xs: '0.875rem', sm: '1rem' },
              mb: { xs: 1.5, sm: 2 },
            }}
          >
            Viewing notes for specific student
          </Typography>
        ) : (
          <Typography 
            variant="subtitle1" 
            component="h2" 
            gutterBottom 
            color="text.secondary"
            sx={{ 
              fontSize: { xs: '0.875rem', sm: '1rem' },
              mb: { xs: 1.5, sm: 2 },
            }}
          >
            Select a class and student to manage notes
          </Typography>
        )}
        <StudentNotes studentId={studentId} showAddNote={true} />
      </Box>
    </PageContainer>
  )
}

export default StudentNotesPage
